import PopParagraph from '@/components/PopUp/PopParagraph'
import PopParagraphView from '@/components/PopUp/PopParagraphView'
import PopImage from '@/components/PopUp/PopImage'
import PopImageView from '@/components/PopUp/PopImageView'
import PopList from '@/components/PopUp/PopList'
import PopListView from '@/components/PopUp/PopListView'
import PopOrderList from '@/components/PopUp/PopOrderList'
import PopOrderListView from '@/components/PopUp/PopOrderListView'
import PopBreak from '@/components/PopUp/PopBreak'
import PopBreakView from '@/components/PopUp/PopBreakView'
import {markRaw} from 'vue'

export const template = [
    {
        type: 'paragraph',
        name: 'paragraph',
        paragraph: '',
        template: markRaw(PopParagraph),
        view: markRaw(PopParagraphView)
    },
    {
        type: 'image',
        name: 'image',
        imageSrc: '',
        template: markRaw(PopImage),
        view: markRaw(PopImageView)
    },
    {
        type: 'list',
        name: 'list',
        list: [],
        template: markRaw(PopList),
        view: markRaw(PopListView)
    },
    {
        type: 'orderList',
        name: 'orderList',
        list: [],
        template: markRaw(PopOrderList),
        view: markRaw(PopOrderListView)
    },
    {
        type: 'break',
        name: 'break',
        popBreak: true,
        template: markRaw(PopBreak),
        view: markRaw(PopBreakView)
    }
]
    
